module.exports = __webpack_public_path__ + "band_8.d450eaf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_8.png
// module id = XXZb
// module chunks = 0